import { IApiError } from '@/models/apiError.model';
import { IGeneratedQrListResponse } from '@/models/generateQr.model';

export const GENERATED_QR_SLICE_NAME = 'generatedQr';

export interface ProductsImportState {
  isLoading: boolean;
  productsQrList: IGeneratedQrListResponse | null;
  error: IApiError | null;
}

export const initialState: ProductsImportState = {
  isLoading: false,
  productsQrList: null,
  error: null,
};
